import { inject, Injectable } from '@angular/core';
import { AppRoute } from '@enums';
import { Platform, RemoteConfigService, WINDOW } from 'moddy/common';

@Injectable({
    providedIn: 'root'
})
export class TwitchBotIntegrationService {
    private readonly remoteConfig = inject(RemoteConfigService);
    private readonly window = inject(WINDOW);

    public integrate(): void {
        const platform: Platform = 'twitch';
        const clientId = this.remoteConfig.getItem('twitchIntegrationAppClientId').asString();
        const redirectUrl = `${this.window.location.origin}/${AppRoute.Root.LinkAccount}/${platform}`;
        const url =
            `https://id.twitch.tv/oauth2/authorize?client_id=${clientId}` +
            `&redirect_uri=${redirectUrl}&response_type=token`;

        this.window.open(url);
    }
}
